<template>
	<div
		class="g-block-body-left-bar g-block-body-padding"
		:class="{
			'g-block-body-left-bar--edit': editable,
			'is-active': editable && active,
			'g-block-body-left-bar--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-left-bar__panel">
			<span
				class="g-block-body-left-bar__bar"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></span>
			<div class="g-block-body-left-bar__main">
				<RichTextEditable
					v-if="editable"
					class="g-block-body-left-bar__title"
					fit-content
					:model-value="data.title"
					placeholder="请输入标题"
					@update:model-value="onTitleUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-left-bar__title"
					v-html="data.title || ''"
				></div>
				<RichTextEditable
					v-if="editable"
					class="g-block-body-left-bar__text"
					:model-value="data.content"
					placeholder="请输入正文"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-left-bar__text"
					v-html="data.content || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { bodyCardMixin } from '../shared/bodyCardMixin.js';

	export default {
		name: 'GBlockBodyLeftBar',
		components: { RichTextEditable },
		mixins: [bodyCardMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-left-bar {
		.body-block-edit-shell();
	}

	.g-block-body-left-bar__panel {
		display: flex;
		background: #fff;
		overflow: hidden;
	}

	.g-block-body-left-bar__bar {
		width: 4px;
		flex-shrink: 0;
	}

	.g-block-body-left-bar__main {
		flex: 1;
		min-width: 0;
		padding: 12px 14px;
	}

	.g-block-body-left-bar__title {
		.body-title-base();
		margin-bottom: 8px;
	}

	.g-block-body-left-bar__text {
		.body-text-base();
		color: #666;
	}

	.g-block-body-left-bar--h5 {
		.g-block-body-left-bar__bar { width: 0.08rem; }
		.g-block-body-left-bar__main { padding: 0.24rem 0.28rem; }
		.g-block-body-left-bar__title { margin-bottom: 0.16rem; }
		.body-title-base--h5(~'.g-block-body-left-bar__title');
		.body-text-base--h5(~'.g-block-body-left-bar__text');
	}
</style>
